// @ts-nocheck : This mutes all TS errors in file, be careful
import editorChallengeModesRU from "./editor/challenge/modes.ru.md";
import editorChallengeModesEN from "./editor/challenge/modes.en.md";

import playerGuideRU from "./player/main.ru.md";
import playerGuideEN from "./player/main.en.md";

const guides = {
  editor: {
    challenge: {
      modes: {
        ru: editorChallengeModesRU,
        en: editorChallengeModesEN
      }
    }
  },
  player: {
    main: {
      ru: playerGuideRU,
      en: playerGuideEN
    }
  }
}

export default guides;
